<template>
	<div class="main-contents">
		 <div class="contents">
			<div class="contents_body">
				<div class="tit">
					<span>회원탈퇴</span>
				</div>
            </div>
        </div>
		<div class="mem_container">
			<div class="main-box">                   
                <div class="mem_contents_body">
					<div class="info-box leave">
						<div class="guide-text">
							<span>
								그동안 그레이트프로와 함께해 주셔서 감사합니다.
							</span>
							<br />
							탈퇴가 정상적으로 처리되었습니다. <br />
							그레이트프로는 언제나 회원님의 성공을 응원하며, <br /> 
							언제든 다시 함께할 날을 기다리겠습니다.
						</div>
						<div class="confirm-btn" @click="pageMove()">확인</div>
					</div>
				</div>
			</div>
		</div>		
	</div>
</template>

<script>
import { signupDeleteAccountMeta } from '@/utils/meta';
export default {
	metaInfo : signupDeleteAccountMeta,
	methods : {
		pageMove() {
			location.href = '/';
		}
	}
}
</script>